export class Toastr {
    public Message:string = "";
    public Type: number = 1;
    public Duration: number = 1500;
    public TempID:number = 1; //1 Information - 2 Affirmative - 3 Negative - 4 Warning
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}